import * as ReadableAPI from '../ReadableApi'

export const INIT_POST = 'INIT_POST'
export const INIT_PAGE_ALL = 'INIT_PAGE_ALL'

export const INIT_CATEGORIES = 'INIT_CATEGORIES'
export const INIT_REL = 'INIT_REL'
export const FILTER = 'FILTER'
export const ORDER = 'ORDER'
export const PAGE = 'PAGE'
export const ADD_ITEM_MENU = 'ADD_ITEM_MENU'
export const ADD_PAGE = 'ADD_PAGE'
export const ADD_TAG = 'ADD_TAG'
export const PARRILLA = 'PARRILLA'
export const PARRILLAUPDATE = 'PARRILLAUPDATE'
export const ADD_COUNTRY = 'ADD_COUNTRY'


export function initPageAll (page) {
  return {
    type:'INIT_PAGE_ALL',
    page
  }
}

export function addCountry (country) {
  return {
    type:'ADD_COUNTRY',
    country
  }
}

export function initPost (post) {
  return {
    type:'INIT_POST',
    post
  }
}

Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

export function initLocation(data) {
  return dispatch => {
    ReadableAPI.getLocation().then((data) => {
      dispatch(addCountry(data))
      //let json = '{"location":"US","idtag":{"term_id":27,"name":"US","slug":"ven","term_group":0,"term_taxonomy_id":27,"taxonomy":"post_tag","description":"","parent":0,"count":12,"filter":"raw"}}'
      //let jsondata = JSON.parse(json)
      //dispatch(addCountry(jsondata))
    })
  }
}

export function initPostAsync(exclude) {
  return dispatch => {
    ReadableAPI.getPostAll(exclude).then((postObj) => {
      dispatch(initPageAll(postObj['page']))
      let data = postObj['data']
      Object.keys(data).map(function (key) {
        data[key]['categoryObj']=[]
        data[key]['media']=[]
        if (data[key]['categories']){
          data[key]['categories'].map(function (idCat) {
            return ReadableAPI.getCategorybyid (idCat).then((mediaObj) => {
              if(mediaObj.name !== "Slider" && mediaObj.name !== "Columns"){
                data[key]['categoryObj']= data[key]['categoryObj'].concat(mediaObj)
              }
            })
          })
        }

        if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !== "0"){
          // ReadableAPI.getMediabyid(data[key]['featured_media']).then((mediaObj) => {
          //   if(Object.keys(mediaObj.media_details.sizes).length === 0 ){
          //       data[key]['featured_media'] = 0
          //     }
          //   data[key]['media']= mediaObj
          //   dispatch(initPost(data[key]))
          // })
          let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
          Object.keys(mediaObj).map(function (mey) {
            if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
              data[key]['featured_media'] = 0
            }
            data[key]['media']= mediaObj[mey]
            return true
          })
        }
        dispatch(initPost(data[key]))
        return true
      },{})
    })
  }
}

export function initPostCountryAsync(exclude, excludeContry) {
  return dispatch => {
    ReadableAPI.getPostCountryAll(exclude, excludeContry).then((postObj) => {
      dispatch(initPageAll(postObj['page']))
      let data = postObj['data']
      Object.keys(data).map(function (key) {
        data[key]['categoryObj']=[]
        data[key]['media']=[]
        if (data[key]['categories']){
          data[key]['categories'].map(function (idCat) {
            return ReadableAPI.getCategorybyid (idCat).then((mediaObj) => {
              if(mediaObj.name !== "Slider" && mediaObj.name !== "Columns"){
                data[key]['categoryObj']= data[key]['categoryObj'].concat(mediaObj)
              }
            })
          })
        }

        if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !== "0"){
          let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
          Object.keys(mediaObj).map(function (mey) {
            let sizes = mediaObj[mey]['media_details']
            if(sizes !== undefined){
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                data[key]['featured_media'] = 0
              }
            }
            data[key]['media']= mediaObj[mey]
            return true
          })
        }
        dispatch(initPost(data[key]))
        return true
      },{})
    })
  }
}

export function postCountrySearchAsync(stringSearch, exclude, excludeContry) {
  return dispatch => {
    ReadableAPI.getPostCountrySearch(stringSearch, exclude, excludeContry).then((postObj) => {
      dispatch(initPageAll(postObj['page']))
      let data = postObj['data']
      Object.keys(data).map(function (key) {
        data[key]['categoryObj']=[]
        data[key]['media']=[]
        if (data[key]['categories']){
          data[key]['categories'].map(function (idCat) {
            return ReadableAPI.getCategorybyid (idCat).then((mediaObj) => {
              if(mediaObj.name !== "Slider" && mediaObj.name !== "Columns"){
                data[key]['categoryObj']= data[key]['categoryObj'].concat(mediaObj)
              }
            })
          })
        }

        if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !== "0"){
          let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
          Object.keys(mediaObj).map(function (mey) {
            let sizes = mediaObj[mey]['media_details']
            if(sizes !== undefined){
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                data[key]['featured_media'] = 0
              }
            }
            data[key]['media']= mediaObj[mey]
            return true
          })
        }
        dispatch(initPost(data[key]))
        return true
      },{})
    })
  }
}

export function PostPageSearchAsync(page, string, excludeContry) {
  return dispatch => {
    ReadableAPI.getPostPageCountrySearch(string, page, excludeContry)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['categoryObj']=[]
          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }
          postObj[key]['media']=[]
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }
          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch((e)=>{
        console.log('error '+e)
      })

  }
}

export function PostPageAsync(page, exclude) {
  return dispatch => {
    ReadableAPI.getPostPage(page, exclude)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['categoryObj']=[]
          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }
          postObj[key]['media']=[]
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }
          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch((e)=>{
        console.log('error '+e)
      })

  }
}

export function CategoryPostPageAsync(page, idCat) {
  return dispatch => {
    ReadableAPI.getPostPageCategory(page, idCat)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }else{
            postObj[key]['categoryObj']=[]
          }
          postObj[key]['media']=[]
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }
          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function PostSlugAsync(slug) {
  return dispatch => {
    ReadableAPI.getPostbySlug(slug)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          if(Object.size(postObj[key]['tags']) > 0){
            ReadableAPI.getPostbyTagid(postObj[key]['tags'], postObj[key]['id']).then((tagObj) => {
              postObj[key]['related']= tagObj
            })
          }else{
            postObj[key]['related']=[]
          }          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }else{
            postObj[key]['categoryObj']=[]
          }
          postObj[key]['media']=[]
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }
          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function array_rand(array){
     return array[~~(Math.random()*(array.length))];
}

export function PostnotSlugAsync(slug) {
  return dispatch => {
    ReadableAPI.getPostbySlug(slug)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['porsrel'] = []
          postObj[key]['media']=[]
          ReadableAPI.getCategorybyid(postObj[key]['categories'][0])
            .then((CatObj) =>{
              dispatch(initCategories(CatObj))
            })
          let catstring = postObj[key]['categories'].toString()
          catstring = catstring.replace(',','+')
          ReadableAPI.getPostbyCategoryexceptId(catstring, postObj[key]['id'])
          .then((postrelObj) => {
            dispatch(initPageAll(postrelObj['page']))
            let data = postrelObj['data']
            Object.keys(data).map(function (keydata) {
              data[keydata]['porsrel'] = []
              if(Object.size(data[keydata]['tags']) > 0){

                ReadableAPI.getPostbyTagid(data[keydata]['tags'], data[key]['id'])
                  .then((tagsObj) => {
                    let elemone = array_rand(tagsObj)
                    let elemtwo = array_rand(tagsObj)
                    if (elemone !== elemtwo){
                      let itemsrel = []
                      itemsrel = itemsrel.concat(elemone)
                      itemsrel = itemsrel.concat(elemtwo)
                      Object.keys(itemsrel).map(function (keytagrel) {
                        itemsrel[keytagrel]['media'] = []
                        if (itemsrel[keytagrel]['featured_media'] !==  '0' && itemsrel[keytagrel]['featured_media'] !== 0 && itemsrel[keytagrel]['featured_media'] !==  "0"){
                          let mediaObj = itemsrel[keytagrel]["_embedded"]["wp:featuredmedia"]
                          Object.keys(mediaObj).map(function (mey) {
                            if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                              itemsrel[keytagrel]['featured_media'] = 0
                            }
                            itemsrel[keytagrel]['media']= mediaObj[mey]
                            return true
                          })

                        }
                        return true
                      },{})
                      data[keydata]['porsrel'] = itemsrel
                      //dispatch(initRel(data[key]))
                    }
                  })
                  .catch(()=>{
                    console.log('error')
                  })
              }
              dispatch(initRel(data[keydata]))
              return true;
            },{})
          })
          .catch(()=>{
            console.log('error cat rel post')
          })
          
          if(Object.size(postObj[key]['tags']) > 0){
            ReadableAPI.getPostbyTagid(postObj[key]['tags'], postObj[key]['id'])
              .then((tagsObj) => {
                let elemone = array_rand(tagsObj)
                let elemtwo = array_rand(tagsObj)
                if (elemone !== elemtwo){
                  let itemsrel = []
                  itemsrel = itemsrel.concat(elemone)
                  itemsrel = itemsrel.concat(elemtwo)
                  
                  Object.keys(itemsrel).map(function (key) {
                    itemsrel[key]['media']=[]
                    if (itemsrel[key]['featured_media'] !==  '0' && itemsrel[key]['featured_media'] !== 0 && itemsrel[key]['featured_media'] !==  "0"){
                      let mediaObj = itemsrel[key]["_embedded"]["wp:featuredmedia"]
                      Object.keys(mediaObj).map(function (mey) {
                        if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                          itemsrel[key]['featured_media'] = 0
                        }
                        itemsrel[key]['media']= mediaObj[mey]
                        return true
                      })
                    }
                    return true
                  },{})
                  postObj[key]['porsrel'] = itemsrel
                }
              })
              .catch(()=>{
                console.log('error')
              })
          }
          Object.keys(postObj).map(function (key) {
            if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
              let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
              Object.keys(mediaObj).map(function (mey) {
                if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                  postObj[key]['featured_media'] = 0
                }
                postObj[key]['media']= mediaObj[mey]
                return true
              })
            }
            dispatch(initPost(postObj[key]))
            return true
          },{})
          return true
        },{})
      })
      .catch((e)=>{
        console.log('error post' + e)
      })

  }
}

export function PostnotSlugAsyncCountry(slug, excludeContry) {
  return dispatch => {
    ReadableAPI.getPostbySlugCountry(slug, excludeContry)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['porsrel'] = []
          postObj[key]['media']=[]
          ReadableAPI.getCategorybyid(postObj[key]['categories'][0])
            .then((CatObj) =>{
              dispatch(initCategories(CatObj))
            })
          let catstring = postObj[key]['categories'].toString()
          catstring = catstring.replace(',','+')
          ReadableAPI.getPostbyCategoryexceptId(catstring, postObj[key]['id'])
          .then((postrelObj) => {
            dispatch(initPageAll(postrelObj['page']))
            let data = postrelObj['data']
            Object.keys(data).map(function (keydata) {
              data[keydata]['porsrel'] = []
              if(Object.size(data[keydata]['tags']) > 0){

                ReadableAPI.getPostbyTagid(data[keydata]['tags'], data[key]['id'])
                  .then((tagsObj) => {
                    let elemone = array_rand(tagsObj)
                    let elemtwo = array_rand(tagsObj)
                    if (elemone !== elemtwo){
                      let itemsrel = []
                      itemsrel = itemsrel.concat(elemone)
                      itemsrel = itemsrel.concat(elemtwo)
                      Object.keys(itemsrel).map(function (keytagrel) {
                        itemsrel[keytagrel]['media'] = []
                        if (itemsrel[keytagrel]['featured_media'] !==  '0' && itemsrel[keytagrel]['featured_media'] !== 0 && itemsrel[keytagrel]['featured_media'] !==  "0"){
                          let mediaObj = itemsrel[keytagrel]["_embedded"]["wp:featuredmedia"]
                          Object.keys(mediaObj).map(function (mey) {
                            if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                              itemsrel[keytagrel]['featured_media'] = 0
                            }
                            itemsrel[keytagrel]['media']= mediaObj[mey]
                            return true
                          })

                        }
                        return true
                      },{})
                      data[keydata]['porsrel'] = itemsrel
                      //dispatch(initRel(data[key]))
                    }
                  })
                  .catch(()=>{
                    console.log('error')
                  })
              }
              dispatch(initRel(data[keydata]))
              return true;
            },{})
          })
          .catch(()=>{
            console.log('error cat rel post')
          })
          
          if(Object.size(postObj[key]['tags']) > 0){
            ReadableAPI.getPostbyTagid(postObj[key]['tags'], postObj[key]['id'])
              .then((tagsObj) => {
                let elemone = array_rand(tagsObj)
                let elemtwo = array_rand(tagsObj)
                if (elemone !== elemtwo){
                  let itemsrel = []
                  itemsrel = itemsrel.concat(elemone)
                  itemsrel = itemsrel.concat(elemtwo)
                  
                  Object.keys(itemsrel).map(function (key) {
                    itemsrel[key]['media']=[]
                    if (itemsrel[key]['featured_media'] !==  '0' && itemsrel[key]['featured_media'] !== 0 && itemsrel[key]['featured_media'] !==  "0"){
                      let mediaObj = itemsrel[key]["_embedded"]["wp:featuredmedia"]
                      Object.keys(mediaObj).map(function (mey) {
                        if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                          itemsrel[key]['featured_media'] = 0
                        }
                        itemsrel[key]['media']= mediaObj[mey]
                        return true
                      })
                    }
                    return true
                  },{})
                  postObj[key]['porsrel'] = itemsrel
                }
              })
              .catch(()=>{
                console.log('error')
              })
          }
          Object.keys(postObj).map(function (key) {
            if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
              let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
              Object.keys(mediaObj).map(function (mey) {
                if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                  postObj[key]['featured_media'] = 0
                }
                postObj[key]['media']= mediaObj[mey]
                return true
              })
            }
            dispatch(initPost(postObj[key]))
            return true
          },{})
          return true
        },{})
      })
      .catch((e)=>{
        console.log('error post' + e)
      })

  }
}

export function PostbyCategorySlug(slug) {
  return dispatch => {
    ReadableAPI.getCategorybySlug(slug)
      .then((CatObj) => {
        if(Object.size(CatObj) === 0){
          let cat = {}
          cat.name = "Resultados de Categoria"
          cat.slug = "search"
          cat.id = 9999999
          cat.description = ""
          cat.meta = []
          cat.parent = 0
          cat.taxonomy = "category"
          cat.count = 0
          dispatch(initCategories(cat))

        }else{
          Object.keys(CatObj).map(function (key) {
            dispatch(initCategories(CatObj[key]))
            ReadableAPI.getPostbyCategory(CatObj[key]['id'])
              .then((postObj) => {
                dispatch(initPageAll(postObj['page']))
                let data = postObj['data']
                Object.keys(data).map(function (key) {
                  if (data[key]['categories']){
                    ReadableAPI.getCategorybyid (data[key]['categories'][0]).then((mediaObj) => {
                      data[key]['categoryObj']= mediaObj
                    })
                  }else{
                    data[key]['categoryObj']=[]
                  }
                  data[key]['media']=[]
                  if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !==  "0"){
                    let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
                    Object.keys(mediaObj).map(function (mey) {
                      let sizes = mediaObj[mey]['media_details']
                      if(sizes !== undefined){
                        if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                          data[key]['featured_media'] = 0
                        }
                      }
                      data[key]['media']= mediaObj[mey]
                      return true
                    })
                  }
                  dispatch(initPost(data[key]))
                  return true
                },{})
              })
              .catch((e)=>{
                console.log('error ' + e)
              })
            return true
          },{})
        }
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function PostbyCategorySlugbyContry(slug, excludeCountry) {
  return dispatch => {
    ReadableAPI.getCategorybySlug(slug)
      .then((CatObj) => {
        if(Object.size(CatObj) === 0){
          let cat = {}
          cat.name = "Resultados de Categoria"
          cat.slug = "search"
          cat.id = 9999999
          cat.description = ""
          cat.meta = []
          cat.parent = 0
          cat.taxonomy = "category"
          cat.count = 0
          dispatch(initCategories(cat))

        }else{
          Object.keys(CatObj).map(function (key) {
            dispatch(initCategories(CatObj[key]))
            ReadableAPI.getPostbyCategorybyCountry(CatObj[key]['id'], excludeCountry)
              .then((postObj) => {
                dispatch(initPageAll(postObj['page']))
                let data = postObj['data']
                Object.keys(data).map(function (key) {
                  if (data[key]['categories']){
                    ReadableAPI.getCategorybyid (data[key]['categories'][0]).then((mediaObj) => {
                      data[key]['categoryObj']= mediaObj
                    })
                  }else{
                    data[key]['categoryObj']=[]
                  }
                  data[key]['media']=[]
                  if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !==  "0"){
                    let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
                    Object.keys(mediaObj).map(function (mey) {
                      if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                        data[key]['featured_media'] = 0
                      }
                      data[key]['media']= mediaObj[mey]
                      return true
                    })
                  }
                  dispatch(initPost(data[key]))
                  return true
                },{})
              })
              .catch(()=>{
                console.log('error')
              })
            return true
          },{})
        }
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function PostbyCategoryParent(catId, tagId) {
  let arrayid = []
  return dispatch => {
    ReadableAPI.getPostbyCategoryparent(catId)
      .then((CatObj) => {
        if(Object.size(CatObj) === 0){
          let cat = {}
          cat.name = "Resultados de Categoria"
          cat.slug = "search"
          cat.id = 9999999
          cat.description = ""
          cat.meta = []
          cat.parent = 0
          cat.taxonomy = "category"
          cat.count = 0
          dispatch(initCategories(cat))

        }else{
          let dataCat = CatObj.data
          Object.keys(dataCat).map(function (key) {
            arrayid.push(dataCat[key]['id'])
            dispatch(initCategories(dataCat[key]))
            return true
          },{})

          if(arrayid.length > 0){
            ReadableAPI.getPostbyCategoryParent(arrayid, tagId)
              .then((postObj) => {
                dispatch(initPageAll(postObj['page']))
                let data = postObj['data']
                Object.keys(data).map(function (key) {
                  data[key][''] = ""
                  
                  data[key]['media']=[]
                  if (data[key]['featured_media'] !==  '0' && data[key]['featured_media'] !== 0 && data[key]['featured_media'] !==  "0"){
                    let mediaObj = data[key]["_embedded"]["wp:featuredmedia"]
                    Object.keys(mediaObj).map(function (mey) {
                      if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                        data[key]['featured_media'] = 0
                      }
                      data[key]['media']= mediaObj[mey]
                      return true
                    })
                  }
                  dispatch(initPost(data[key]))
                  return true
                },{})
              })
              .catch(()=>{
                console.log('error')
              })
              return true
          }
        }
      })
      .catch(()=>{
        console.log('error')
      })
  }
}

export function PostCategoryAsync(idMedia) {
  return dispatch => {
    ReadableAPI.getPostbyCategorybyid(idMedia)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['media']=[]
          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }else{
            postObj[key]['categoryObj']=[]
          }
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            // ReadableAPI.getMediabyid(postObj[key]['featured_media']).then((mediaObj) => {
            //   if(Object.keys(mediaObj.media_details.sizes).length === 0 ){
            //     postObj[key]['featured_media'] = 0
            //   }
            //   postObj[key]['media']= mediaObj
            //   dispatch(initPost(postObj[key]))
            // })
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }

          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch((e)=>{
        console.log(e)
      })

  }
}

export function PostCategoryCountryAsync(idMedia, excludeContry) {
  return dispatch => {
    ReadableAPI.getPostbyCategorybyidCountry(idMedia, excludeContry)
      .then((postObj) => {
        Object.keys(postObj).map(function (key) {
          postObj[key]['media']=[]
          if (postObj[key]['categories']){
            ReadableAPI.getCategorybyid (postObj[key]['categories'][0]).then((mediaObj) => {
              postObj[key]['categoryObj']= mediaObj
            })
          }else{
            postObj[key]['categoryObj']=[]
          }
          if (postObj[key]['featured_media'] !==  '0' && postObj[key]['featured_media'] !== 0 && postObj[key]['featured_media'] !==  "0"){
            // ReadableAPI.getMediabyid(postObj[key]['featured_media']).then((mediaObj) => {
            //   if(Object.keys(mediaObj.media_details.sizes).length === 0 ){
            //     postObj[key]['featured_media'] = 0
            //   }
            //   postObj[key]['media']= mediaObj
            //   dispatch(initPost(postObj[key]))
            // })
            let mediaObj = postObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (mey) {
              if(Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                postObj[key]['featured_media'] = 0
              }
              postObj[key]['media']= mediaObj[mey]
              return true
            })
          }

          dispatch(initPost(postObj[key]))
          return true
        },{})
      })
      .catch((e)=>{
        console.log(e)
      })

  }
}

export function initCategories (categories) {
  return{
    type:'INIT_CATEGORIES',
    categories
  }
}

export function initRel (postrel) {
  return{
    type:'INIT_REL',
    postrel
  }
}

export function getInitListCategories() {
  let arraycat = []
  return dispatch => {
    ReadableAPI.getCategoriesAll().then((categoriesObj) => {
      Object.keys(categoriesObj.categories).map(function (key) {
        return arraycat[key] = categoriesObj.categories[key]
      },{})
      dispatch(initCategories(arraycat))
      return arraycat
    })
  };
}

export function filter (filter) {
  return{
    type:'FILTER',
    filter
  }
}

export function order (order) {
  return{
    type:'ORDER',
    order
  }
}


export function initMenuAsync() {
  return dispatch => {
    ReadableAPI.getMenuAll().then((menuObj) => {
      Object.keys(menuObj).map(function(key){
        return dispatch(addMenuAsync(key, menuObj[key].ID))
      })
    })
  }
}

export function addItemMenu (itemMenu, slug) {
  return{
    type:'ADD_ITEM_MENU',
    slug,
    itemMenu
  }
}

export function addMenuAsync(slug, id) {
  return dispatch => {
    ReadableAPI.getMenubyId(id).then((menuObj) => {
      if(menuObj.items){
        menuObj.items.forEach((element) => {
          dispatch(addItemMenu(element, slug))
        })
      }
    })
  }
}

export function PageAdd (PageObj) {
  return{
    type:'ADD_PAGE',
    PageObj
  }
}

export function PagebySlug(slug) {
  return dispatch => {
    ReadableAPI.getPagesbySlug(slug)
      .then((PageObj) => {
        Object.keys(PageObj).map(function (key) {
          PageObj[key]['media']=[]
          if (!PageObj[key]['video_field']){
            PageObj[key]['video_field'] = []
          }
          if (PageObj[key]['featured_media'] !==  '0' && PageObj[key]['featured_media'] !== 0 && PageObj[key]['featured_media'] !==  "0"){
            let mediaObj = PageObj[key]["_embedded"]["wp:featuredmedia"]
            Object.keys(mediaObj).map(function (key) {
              if(Object.size(mediaObj[key]['media_details']['sizes']) === 0 ){
                PageObj[key]['featured_media'] = 0
              }
              PageObj[key]['media']= mediaObj[key]
              return true
            })
          }else{
            PageObj[key]['media']=[]
          }
          return true
        },{})
        dispatch(PageAdd(PageObj))
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function TagAdd (TagsObj) {
  return{
    type:'ADD_TAG',
    TagsObj
  }
}

export function PostbyTagSlug(slug) {
  return dispatch => {
    ReadableAPI.getTagsbySlug(slug)
      .then((TagObj) => {
        dispatch(TagAdd(TagObj))
        Object.keys(TagObj).map(function(key) {
          ReadableAPI.getPostbyTagid(TagObj[key]['id'])
          .then((PostObj) => {
            Object.keys(PostObj).map(function (key) {
              PostObj[key]['media']=[]
              if (!PostObj[key]['video_field']){
                PostObj[key]['video_field'] = []
              }
              if (PostObj[key]['featured_media'] !==  '0' && PostObj[key]['featured_media'] !== 0 && PostObj[key]['featured_media'] !==  "0"){
                let mediaObj = PostObj[key]["_embedded"]["wp:featuredmedia"]
                Object.keys(mediaObj).map(function (mey) {
                  let sizes = mediaObj[mey]['media_details']
                  if(sizes !== undefined){
                    if(Object.size(mediaObj[mey]['media_details']) === 0 && Object.size(mediaObj[mey]['media_details']['sizes']) === 0 ){
                      PostObj[key]['featured_media'] = 0
                    }
                  }
                  PostObj[key]['media']= mediaObj[mey]
                  return true
                })
              }else{
                PostObj[key]['media']=[]
              }
              dispatch(initPost(PostObj[key]))
              return true
            })
          })
          .catch((e)=>{
            console.log('error', e)
          })
          return true
        })
        
      })
      .catch(()=>{
        console.log('error')
      })

  }
}

export function Parrilla (parrillaObj) {
  return{
    type:'PARRILLA',
    parrillaObj
  }
}

export function ParrillaUpdate (parrillaObj) {
  return{
    type:'PARRILLAUPDATE',
    parrillaObj
  }
}

export function DataSpreedshet(dataid, tag, page){
  return dispatch => {
    ReadableAPI.getDataSpreed(dataid, page)
      .then((dataspreed) => {
        let arraykey = []
        let objdata = dataspreed.feed.entry
        Object.keys(objdata).map(function (mey) {
          let arrayitem = []
          if(objdata[mey].gsx$nombre.$t.length > 0){
            arrayitem['date'] = objdata[mey].gsx$fecha.$t.split("/")
            arrayitem['hor'] = objdata[mey].gsx$hora.$t
            arrayitem['name'] = objdata[mey].gsx$nombre.$t
            arrayitem['datapost'] = []
            if(arraykey.indexOf(arrayitem['name']) === -1 ){
              ReadableAPI.getSearchbystringbytag(arrayitem['name'], tag)
                .then((datapost) => {
                  dispatch(ParrillaUpdate(datapost))
                })
                .catch((e)=>{
                  console.log('error' + e)
                })
              arraykey.push(arrayitem['name'])
            }
            let arrayjson = Object.assign({}, arrayitem)
            dispatch(Parrilla(arrayjson))
          }
          return true
        })
        return true
      })
      .catch(()=>{
        console.log('error')
        return false
      })
  }
}




// WEBPACK FOOTER //
// ./src/actions/index.js